import React, { Component } from "react";

import { CNav, CNavItem, CNavLink, CCol } from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ExperimentCard from "./components/ExperimentCard";
import Interface from "../../components/Interface";
import Loading from "../../components/Loading";
import URL from "../../config/api";
import axios from "../../config/axios";

class Newton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      search: "",
      tab: 0,
      iframe: false,
      content: null,
      objective: null
    };
  }

  componentDidMount() {
    axios
      .get(`${URL.api}classification/objective/singleViewByCode/Newton`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(respObjective => {
        const filters = {
          type: 6,
          segment: null,
          discipline: null,
          serie: null,
          ability: null,
          content: true
        };

        axios
          .post(`${URL.api}content/los/listLosFilter`, filters, {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          })
          .then(resp => {
            this.setState({
              content: resp.data.data,
              objective: respObjective.data.data,
              loading: false
            });
          });
      });
  }

  filter(shouldLoad = true) {
    if (shouldLoad) {
      this.setState({ loading: true });
    }

    const filters = {
      type: 6,
      word: this.state.search,
      segment: null,
      discipline: null,
      serie: null,
      ability: this.state.tab || null,
      content: true
    };

    axios
      .post(`${URL.api}content/los/listLosFilter`, filters, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ content: resp.data.data, loading: false });
      });
  }

  render() {
    if (this.state.iframe) {
      return (
        <div className="w-100 h-100">
          <Interface
            show
            modal={false}
            aula={this.state.iframe}
            currentRoute={this.props.currentRoute}
          />
        </div>
      );
    }

    return (
      <div className="d-flex flex-column">
        <div
          className="bg-light pt-5"
          style={{ borderBottom: "1px solid #d8dbe0" }}
        >
          <div className="container">
            <h1 className="text-dark">
              <i className="fa fa-lightbulb-o mr-3 text-warning"></i>
              Newton
            </h1>
            <div className="mb-3 text-muted">
              Laboratório virtual de física da Educadus
            </div>
            <div className="w-100 d-flex">
              <CNav
                variant="tabs"
                className="nav-underline nav-underline-info"
                style={{
                  marginBottom: "1px",
                  borderWidth: "0px",
                  fontWeight: "600"
                }}
              >
                <CNavItem>
                  <CNavLink
                    className="p-3"
                    active={this.state.tab === 0}
                    onClick={() => this.setState({ tab: 0 })}
                  >
                    Todos
                  </CNavLink>
                </CNavItem>
                {this.state.objective?.abilities.map(ability => (
                  <CNavItem key={ability.id}>
                    <CNavLink
                      className="p-3"
                      active={this.state.tab === ability.id}
                      onClick={() =>
                        this.setState({ tab: ability.id }, () => this.filter())
                      }
                    >
                      {ability.description}
                    </CNavLink>
                  </CNavItem>
                ))}
              </CNav>
            </div>
          </div>
        </div>
        <div className="container pt-4">
          <div className="row">
            {this.state.loading ? (
              <div className="p-4 w-100 d-flex align-items-center justify-content-center">
                <Loading />
              </div>
            ) : this.state.content.length === 0 ? (
              <div className="p-4 w-100 d-flex align-items-center justify-content-center text-muted">
                Nenhum simulador encontrado
              </div>
            ) : (
              <div
                className="row"
                style={{ marginBottom: "-1.5rem", width: "100%" }}
              >
                {this.state.content[0].content.map(newton => (
                  <CCol key={newton.id} xs="4" lg="3">
                    <ExperimentCard
                      onClick={() => this.setState({ iframe: newton.id })}
                      image={
                        URL.img + (newton.image || "uploads/lo/noPicture.jpg")
                      }
                      name={newton.name}
                      progress={25}
                      description={newton.resume || "Sem descrição"}
                      type={newton.ability_description}
                    />
                  </CCol>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Newton);
